import * as yup from 'yup';

export const filterSchema = yup.object().shape({
  project: yup.string(),
  q: yup.string(),
  channel: yup.string(),
});
